<template>
  <div id="app" ref="main">
    <Header @muteds="muterds($event)" ></Header>
    <div :style="{'height':height}"></div>
    <router-view :muted="muted" />
    <Footer></Footer>
  </div>
</template>

<script>
import Header from './components/Header/Header.vue'
import Footer from './components/Footer/Footer.vue'
export default {
  name: 'App',
  components: {
    Header,
    Footer
  },
  data(){
    
    return{
      muted:true,
      height:''
    }
  },
  watch:{
    $route(){
      let main = this.$refs.main
      window.scrollTo(0,0)
    },
   
  },
  mounted(){
    let inwidth=window.innerWidth
        if(inwidth>=1024){
          this.height='10vh'
        }else{
          this.height='5rem'
        }
    window.onbeforeunload = function (e) {
      window.scrollTo(0,0)
        };
  },
  methods:{
    muterds(is){
      this.muted = is;
    }
  }
}
</script>

<style>
#app {
  font-family: 'MicrosoftYaHei';
}
.mouse-cover-canvas{
  position: absolute;
  width: 33%;
  height: 500px;
  left: 17% !important;
  top: 660px !important;
  border: 1px solid  #eeeeee;
  background-color: #eeeeee;
  z-index: 99999;
  display: none;
}
 
</style>
